import { call, put, select, takeLatest } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { AlertDetails, AlertsActionTypes } from 'app/modules/alerts/models';
import {
  RetrieveAlertEntitiesPayload,
  RetrieveAlertTxnsPayload,
} from 'app/modules/alerts/requests';

// Actions
import {
  retrieveAlert as retrieveAlertAction,
  retrieveAlertSuccess,
  retrieveAlertEntities,
  retrieveAlertTransactions,
} from 'app/modules/alerts/actions';
import { retrieveCustomChecklistSubmission } from 'app/shared/customChecklist/actions';

// API
import { getAlert as getAlertApi } from 'app/shared/api/alerts';

// Selectors
import { selectHasReadAlertsPermission } from 'app/modules/session/selectors';

// Constants
import { DEFAULT_PAGINATION_PAYLOAD } from 'app/shared/pagination/constants';

const rootAction = AlertsActionTypes.RETRIEVE_ALERT;
export function* retrieveAlert({
  payload: { id, useAlertTxnCacheEndpoint },
}: ReturnType<typeof retrieveAlertAction>) {
  const config = {
    rootAction,
    request: call(getAlertApi, id),
    success: function* onSuccess(result: AlertDetails) {
      yield put(retrieveAlertSuccess(result));

      const hasReadAlertsPermission: boolean = yield select(
        selectHasReadAlertsPermission,
      );
      if (!hasReadAlertsPermission) return;

      const entitiesPayload: RetrieveAlertEntitiesPayload = {
        alertId: String(result.id),
        ...DEFAULT_PAGINATION_PAYLOAD,
      };

      const transactionsPayload: RetrieveAlertTxnsPayload = {
        hash_key: String(result.id),
        useCacheEndpoint: useAlertTxnCacheEndpoint,
        ...DEFAULT_PAGINATION_PAYLOAD,
      };

      yield put(retrieveAlertEntities(entitiesPayload));
      yield put(retrieveAlertTransactions(transactionsPayload));
      yield put(retrieveCustomChecklistSubmission(result.id));
    },
  };

  yield call(makeSagaRequest, config);
}

export default function* watchRetrieveAlert() {
  yield takeLatest(rootAction, retrieveAlert);
}
